<template>
  <section class="shop">
    <div class="heading">
      <div class="heading-container">
        <h3>our shop</h3>
        <p>
          <router-link :to="{ name: 'Home' }" class="home text-decoration-none"
            >home</router-link
          >
          / <span>shop</span>
        </p>
      </div>
    </div>
    <Category />
    <Products />
  </section>
</template>

<script>
import Products from "../components/Products";
import Category from "../components/Category";
export default {
  components: {
    Category,
    Products,
  },
};
</script>